<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.machinesafety.guards-tested' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="guardsTested" />
                <div class="ir-line ir-select th-select" (click)="openYesNoSelector('guardsTested')">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHTML]="editForm.controls.guardsTested.value | machinesafetyyesno"></span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.machinesafety.guards-secured' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="guardsSecured" />
                <div class="ir-line ir-select th-select" (click)="openYesNoSelector('guardsSecured')">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHTML]="editForm.controls.guardsSecured.value | machinesafetyyesno"></span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.machinesafety.customer-informed-name' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input name="customerInformedName" class="ir-form-set" type="text" formControlName="customerInformedName" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.machinesafety.parts-needed' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="partsNeeded" />
                <div class="ir-line ir-select th-select" (click)="openYesNoSelector('partsNeeded')">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHTML]="editForm.controls.partsNeeded.value | machinesafetyyesno"></span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.machinesafety.comment' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <textarea name="comment" class="ir-form-set" formControlName="comment" rows="5"></textarea>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectYesNoMenu($event)" (modalClosed)="onClose($event)" #yesNoModal></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
